module.exports = "<div class=\"ui-modals\">\n\n  <ui-modal ng-repeat=\"modal in $ctrl.getModalsList()\"\n            modal=\"modal\">\n  </ui-modal>\n\n</div>";